<template>
  <ul ref="compliance" class="compliance">
    <slot />
  </ul>
</template>
<script>
export default {
  name: 'Compliance',
  props: {
    complianceTheme: {
      type: String,
      default: '#dbdde0'
    },
    complianceBg: {
      type: String,
      default: '#fff',
    }
  },
  mounted() {
  }
}
</script>
<style>
  .compliance {
    padding: 0;
    position: relative;
    list-style: none;
    -webkit-font-smoothing: antialiased;
    margin: 15px 20px;
    padding: 0 0 0 2.5em;
  }
</style>